export default __webpack_public_path__ + "static/media/info-icon.62d5cd6a.svg";